module.exports = __webpack_public_path__ + "media/7.d7db293d.mp3";